module.exports = __webpack_public_path__ + "static/img/clause_letter102.40af7cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_letter102.png
// module id = qjbH
// module chunks = 1